/**
 * Error to facilitate exhastive type check.
 * Used in cases when there's an enum or discriminated union type
 * and you want to perform switch (or if/else) over all cases (exhaustive)
 * but ensuring in compilation time that future values of that enum will be supported as well.
 * @example:
 * ```ts
 * enum Values { Value1, Value2 }
 * ...
 * const variable: Value = ...;
 * switch (variable) {
 *  case Value1: ...; break;
 *  case Value2: ...; break;
 *  default: throw ExhaustiveTypeCheckFailedError(variable);
 * }
 * ```
 *
 * If Values enum will get another value of e.g. `Value3`, the sample won't compile till `Value3` is added to the switch.
 */
export class ExhaustiveTypeCheckFailedError extends Error {
	constructor(val: never) {
		super(`Unreachable case: ${val}`);
	}
}
